export default {
  cloud_name: process.env.REACT_APP_CLOUDINARY_NAME,
  unsigned_upload_preset: process.env.REACT_APP_CLOUDINARY_PRESET
}
